import { render, staticRenderFns } from "./ConfigReportGeneral.vue.js?vue&type=template&id=83483b60&scoped=true!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=template&id=83483b60&scoped=true"
import script from "./ConfigReportGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=script&lang=js"
export * from "./ConfigReportGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigReportGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83483b60",
  null
  
)

export default component.exports